<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'approve',
    subject: 'Document',
  },
})

const page = {
  groupTitle: 'Dokumen',
  icon: 'ri-checkbox-circle-line',
  color: 'success',
  title: 'Approval Dokumen',
  description: 'Menyetujui atau menolak dokumen yang sedang diajukan untuk direview.',
  purpose: 'Menjelaskan cara kerja tahap persetujuan berjenjang sebuah dokumen, dan apa yang harus dilakukan seorang approver.',
  concept: [
    {
      icon: 'ri-git-branch-line',
      title: 'Approval Berjenjang',
      text: 'Satu dokumen bisa butuh persetujuan lebih dari satu orang secara berurutan (mis. Kepala Unit → Ketua Tim Mutu → Direktur). Anda hanya diminta bertindak kalau giliran Anda sudah tiba.',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Kenapa Saya Tidak Lihat Tombol Setujui?',
      text: 'Tombol hanya muncul kalau Anda memang approver untuk langkah yang sedang berjalan saat ini. Kalau dokumen masih menunggu approver sebelum Anda, tombol belum akan muncul.',
    },
  ],
  steps: [
    { title: 'Buka detail dokumen yang statusnya "Review"', detail: 'Bisa dari halaman detail dokumen langsung, atau dari notifikasi yang Anda terima.' },
    { title: 'Baca isi dokumen dan lampirannya', detail: 'Pastikan Anda benar-benar membaca sebelum memutuskan.' },
    { title: 'Klik "Setujui" atau "Tolak"', detail: 'Kalau menolak, Anda wajib mengisi alasan penolakan — ini akan terlihat oleh pembuat dokumen.' },
    { title: 'Kalau menyetujui, dokumen lanjut ke approver berikutnya', detail: 'Kalau Anda adalah approver terakhir, status dokumen otomatis berubah menjadi Approved.' },
  ],
  tips: [
    'Menolak dokumen mengembalikan statusnya ke Draft — pembuat dokumen harus memperbaiki lalu mengajukan ulang dari awal.',
    'Anda bisa melihat riwayat lengkap siapa sudah menyetujui apa di tab riwayat approval pada halaman detail dokumen.',
  ],
  faq: [
    { q: 'Bisakah saya membatalkan persetujuan yang sudah saya berikan?', a: 'Tidak. Keputusan approval bersifat final untuk menjaga jejak audit yang jelas — kalau ternyata salah, dokumen harus diajukan ulang dari awal setelah diperbaiki.' },
    { q: 'Kenapa saya tidak bisa menyetujui dokumen padahal role saya "bisa approve"?', a: 'Punya izin approve secara umum tidak cukup — Anda juga harus terdaftar sebagai approver di langkah yang sedang berjalan untuk dokumen itu spesifik. Cek dengan admin yang mengatur Approval Flow-nya.' },
  ],
  related: [
    { title: 'Kelola Dokumen', sub: 'Siklus hidup dokumen dari draf sampai terbit', icon: 'ri-file-text-line', color: 'primary', to: { name: 'help-dokumen-kelola-dokumen' } },
    { title: 'Setup Approval Flow', sub: 'Atur siapa menyetujui apa', icon: 'ri-git-branch-line', color: 'warning', to: { name: 'help-administrasi-setup-approval-flow' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
